import React, { useState } from 'react';
import { API_BASE_URL } from 'config/api';

// Import view component
import GalleryView from './view';

const GalleryContainer = ({
  // Data from parent
  orderedImages = [],
  orderedNewImages = [],

  // Handlers from parent
  onImagesChange,
  onImageUpload,
  onImageDelete,
  onImageMoveLeft,
  onImageMoveRight,

  // UI props
  showSnackbar,
  disableSaveButton = false
}) => {
  // Local UI state only - no business logic
  const [previewImage, setPreviewImage] = useState(null);
  const [error, setError] = useState(null);

  // Function to get unique identifier for an image
  const getImageIdentifier = (image) => {
    return image.slug || image.id || Math.random().toString(36).substring(2);
  };

  // Replace your getImageUrl function with this debug version

  const getImageUrl = (image) => {
    if (!image) return '';

    // For blob URLs (new images), use directly
    if (image.url && image.url.startsWith('blob:')) {
      return image.url;
    }

    // For Django image URLs, add API_BASE_URL if needed (only for relative paths)
    if (image.url) {
      if (image.url.startsWith('http')) return image.url;
      return image.url.startsWith('/') ? `${API_BASE_URL}${image.url}` : image.url;
    }

    if (image.image) {
      if (image.image.startsWith('http')) return image.image;
      return image.image.startsWith('/') ? `${API_BASE_URL}${image.image}` : image.image;
    }

    return '';
  };

  // Handle image upload from file input - just pass files to parent
  const handleImageUpload = (e) => {
    if (!e.target.files || e.target.files.length === 0) return;

    try {
      const files = Array.from(e.target.files);
      if (onImageUpload) {
        onImageUpload(files);
      }
      e.target.value = ''; // Reset file input
    } catch (error) {
      console.error('Error handling image upload:', error);
      setError('Error uploading images');
      showSnackbar?.('Error uploading images', 'error');
    }
  };

  // Handle moving an image left - just pass to parent
  const handleMoveLeft = (index, isNew = false) => {
    if (index === 0) return;
    if (onImageMoveLeft) {
      onImageMoveLeft(index, isNew);
    }
  };

  // Handle moving an image right - just pass to parent
  const handleMoveRight = (index, isNew = false) => {
    const relevantArray = isNew ? orderedNewImages : orderedImages;
    if (index >= relevantArray.length - 1) return;

    if (onImageMoveRight) {
      onImageMoveRight(index, isNew);
    }
  };

  // Handle deleting an image - just pass to parent
  const handleImageDelete = (index, isNew = false) => {
    if (onImageDelete) {
      onImageDelete(index, isNew);
    }
  };

  // Open preview dialog for an image
  const handlePreviewImage = (image) => {
    setPreviewImage(image);
  };

  // Close preview dialog
  const handleClosePreview = () => {
    setPreviewImage(null);
  };

  return (
    <GalleryView
      orderedImages={orderedImages}
      orderedNewImages={orderedNewImages}
      isLoadingState={false} // No more internal loading state
      previewImage={previewImage}
      error={error}
      snackbarState={{ open: false }} // No more internal snackbar
      disableSaveButton={disableSaveButton}
      getImageIdentifier={getImageIdentifier}
      getImageUrl={getImageUrl}
      handleImageUpload={handleImageUpload}
      handlePreviewImage={handlePreviewImage}
      handleClosePreview={handleClosePreview}
      handleMoveLeft={handleMoveLeft}
      handleMoveRight={handleMoveRight}
      handleImageDelete={handleImageDelete}
      handleSaveGallery={() => { }} // No-op since parent handles saving
      handleCloseSnackbar={() => { }} // No-op since no internal snackbar
    />
  );
};

export default GalleryContainer;